(function(window, angular, undefined) {
    angular.module('formApp')
        .filter("articleDeterminer", function() { // register new filter
            return function(input) { // filter arguments
                if (['a','e','i','o','u'].indexOf(input.slice(0,1).toLowerCase()) === -1) {
                    return 'a ' + input;
                } else {
                    return 'an ' + input;
                }
            };
        });
})(window, window.angular);